import React from 'react'
import { FocusTrap, Modal, Text } from '@mantine/core'

export const requiredMark = (
  <span
    style={{
      backgroundColor: 'var(--mantine-color-invy-6)',
      color: '#fff',
      borderRadius: '2px',
      padding: '4px',
    }}
  >
    必須
  </span>
)

export const requireLabelStyles = {
  label: {
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
}

interface Props {
  opened: boolean
  onClose: () => void
  title: React.ReactNode
  width?: number | string
  size?: number | string
  zIndex?: number
  onExited?: () => void
  children: React.ReactNode
}

export const BaseModal: React.FC<Props> = ({
  opened,
  onClose,
  title,
  width = 800,
  size,
  zIndex,
  onExited,
  children,
}) => {
  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      centered
      yOffset={0}
      size={size ? `${size}` : 'lg'}
      zIndex={zIndex}
      transitionProps={{ transition: 'pop', onExited }}
      styles={{
        inner: {
          flexDirection: 'column',
        },
        content: {
          width,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 16,
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <FocusTrap.InitialFocus />
        <Modal.Header style={{ borderBottom: '1px solid #0000001A', flexShrink: 0 }}>
          <Modal.Title>
            {typeof title === 'string' ? <Text fw={600}>{title}</Text> : title}
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body
          style={{
            padding: 0,
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
